import { render, staticRenderFns } from "./db-manage.vue?vue&type=template&id=70ca1b12&"
import script from "./db-manage.vue?vue&type=script&lang=js&"
export * from "./db-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports